var _path, _path2, _ellipse, _ellipse2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcAndroidWear(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 2463.28 1735.62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic_android_wear") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M181.28,26.13c122.22-51,263.4,5.05,315.29,125.18l544.77,1261.05c51.92,120.13-5.11,258.82-127.36,309.8s-263.42-5-315.29-125.15L53.9,335.93C2,215.82,59,77.11,181.28,26.11Z",
    transform: "translate(-34.72 -5.39)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M956.09,26.13c122.22-51,263.39,5.05,315.29,125.18l544.77,1261.05c51.92,120.13-5.12,258.82-127.36,309.8s-263.42-5-315.29-125.15L828.7,335.93c-51.89-120.11,5.14-258.82,127.39-309.8Z",
    transform: "translate(-34.72 -5.39)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2209.48,
    cy: 249.38,
    rx: 253.81,
    ry: 249.38
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1968.99,
    cy: 800.69,
    rx: 253.81,
    ry: 249.38
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAndroidWear);
export default __webpack_public_path__ + "static/media/ic_android_wear.05ff5124c269612bcba39e6f8bae55c1.svg";
export { ForwardRef as ReactComponent };